'use client'

import { useEffect, useState } from 'react'

import { useSession } from '@rewardops/auth'
import { useLocale } from '@rewardops/ui'

import { useApi } from './use-api'

function useUnauthRedirect(redirectAutomatically?: boolean) {
  const [redirectUrl, setRedirectUrl] = useState<string>('')
  const { data: session, isLoading } = useSession()
  const { locale } = useLocale()
  const { tenant } = useApi()

  useEffect(() => {
    if (!isLoading && !session?.user && Boolean(redirectUrl)) {
      if (tenant?.loginLink?.[locale]) {
        window.location.href = tenant.loginLink[locale]
      } else {
        setRedirectUrl('')
        fetch(
          `/api/auth/login?returnUrl=${encodeURIComponent(
            redirectUrl,
          )}&locale=${locale}`,
        )
          .then((response) => response.json())
          .then((response) => {
            window.location.href = response.authRedirect?.url
          })
      }
    }
  }, [isLoading, redirectUrl])

  useEffect(() => {
    if (redirectAutomatically) {
      setRedirectUrl(window?.location?.href)
    }
  }, [])

  const redirectUnauthenticatedUser = (customReturnUrl?: string) => {
    setRedirectUrl(customReturnUrl ?? window.location.href)
  }

  return {
    sessionLoading: isLoading,
    isAuthenticated: Boolean(session?.user),
    redirectUnauthenticatedUser,
  }
}

export default useUnauthRedirect
